var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMondayDarkBlue01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1900,
    height: 414,
    viewBox: "0 0 1900 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1900,
    height: 414,
    fill: "#242e45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-monday",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g853",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g847",
    transform: "translate(0 98.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path841",
    d: "M46.707,225.11A46.886,46.886,0,0,1,5.846,201.4,45.335,45.335,0,0,1,7.13,154.727L91.275,22.59a47.13,47.13,0,0,1,81.739,2.21,45.293,45.293,0,0,1-2.532,46.6L86.39,203.539A46.9,46.9,0,0,1,46.707,225.11Z",
    transform: "translate(0 0.001)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path843",
    d: "M76.559,225.106A46.747,46.747,0,0,1,35.77,201.449,45.193,45.193,0,0,1,37.053,154.9L121.039,23.067a47.081,47.081,0,0,1,82.042,1.872,45.191,45.191,0,0,1-3.031,46.815L116.083,203.588a46.833,46.833,0,0,1-39.524,21.518Z",
    transform: "translate(114.478 0.005)",
    fill: "#242e45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse845",
    cx: 43.321,
    cy: 42.412,
    rx: 43.321,
    ry: 42.412,
    transform: "translate(288.821 141.393)",
    fill: "#242e45"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path851",
    d: "M1530.1,109.746h-63.306l-44.372,114.4-44.141-114.4h-63.305l76.961,180.77L1344.07,410.031h62.842Zm-385,100.547c0,28.88,25.244,47.885,50.042,47.885,24.37,0,48.312-17.685,48.312-47.9s-23.942-47.92-48.312-47.92c-24.8,0-50.042,19.022-50.042,47.92Zm98.354,100.939V288.359c-12.836,19.432-42.786,26.777-58.153,26.777-50.88,0-101.777-40.112-101.777-104.861,0-64.732,50.879-104.843,101.777-104.843,12.818,0,42.768,4.279,58.153,26.741V109.817h59.009v201.45l-59.009-.018Zm-176.724,0h-59.009V286.2c-9.859,18.541-33.765,29.344-58.581,29.344-51.325,0-96.66-40.985-96.66-104.451,0-64.66,45.335-105.7,96.66-105.7,24.78,0,48.758,10.34,58.581,28.9V0h59.009Zm-60.292-101.4c0-30.2-21.8-47.9-46.173-47.9-25.244,0-46.209,18.986-46.209,47.9,0,29.843,20.965,48.74,46.191,48.74,24.834.036,46.191-19.824,46.191-48.74ZM706.58,204.626c0-30.628,15.831-40.985,36.778-40.985,20.091,0,34.639,13.371,34.639,40.112V311.2H837.43V190.825c0-57.369-28.239-85.429-73.146-85.429-23.514,0-47.029,13.371-57.725,33.658V109.746h-59.4V311.2h59.419ZM526.466,314.655c-56.442,0-103.524-41.413-103.524-104.843,0-63.466,47.029-104.469,103.524-104.469s103.934,41,103.934,104.469-47.493,104.86-103.934,104.86Zm0-58.652c24.78,0,45.335-18.148,45.335-46.173,0-27.187-20.537-45.745-45.335-45.745a44,44,0,0,0-32.125,13.21,44.8,44.8,0,0,0-12.782,32.535C481.576,237.89,502.1,256,526.466,256ZM316.387,163.656c17.524,0,32.927,13.816,32.927,40.112V311.232h59.009V196.815c0-60.827-29.576-91.455-76.979-91.455-14.084,0-40.611,4.279-59.865,35.8-11.124-23.3-32.5-35.388-64.09-35.388A57.1,57.1,0,0,0,155.227,139V109.764H95.754v201.45h59.419V204.624c0-30.628,16.687-40.985,34.639-40.985,17.114,0,32.482,13.371,32.927,38.828V311.214h59.437V204.624c0-29.291,15.4-40.95,34.211-40.95Z",
    transform: "translate(366.154)",
    fill: "#242e45",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMondayDarkBlue01);
export default __webpack_public_path__ + "static/media/logo-monday-dark-blue-01.9d558a6912f03e4d6b28fe2c2042e98c.svg";
export { ForwardRef as ReactComponent };